import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getTags() {
    return axios.get(ENV.systemBase + "/tags/list", this.requestConfig());
  }

  static createTag(requestData) {
    return axios.post(ENV.systemBase + "/tags/create", requestData, this.requestConfig());
  }

  static updateTags(requestData) {
    return axios.post(ENV.systemBase + "/tags/update", requestData, this.requestConfig());
  }

  static deleteTag(requestData) {
    return axios.post(ENV.systemBase + "/tags/delete", requestData, this.requestConfig());
  }
}

export default Service;
